const value = {
    label: 'Log in',
    btnLabel: 'Log in',
    login: 'Login',
    password: 'Password',
    method: 'Login method',
    basic: 'Basic authentication',
    incorrectValid: 'Invalid login or password',
  };

export default value;
